<script>
  // import Location from '../location/Location.svelte';
  import Location from '../location/Location.new.svelte';
  import ProfileInfo from './components/ProfileInfo.svelte';
  import TabBar from '../lib/components/TabBar.svelte';
  import WorkerAccomplishments from './components/WorkerAccomplishments.svelte';
  import WorkerExperiences from './components/WorkerExperiences.svelte';
  import WorkerProfileTaskInterests from './components/WorkerProfileTaskInterests.svelte';

  import Settings from './settings';

  import APIClient from '../state-charts/api-client';
  import { TS } from '../config/translation-keys.js';
  import { t9n } from '../lib/translate.js';
  import session from '../lib/session.js';
  import { onDestroy, onMount } from 'svelte';
  import Dialog from '../lib/components/Dialog.svelte';
  import { compareStrings } from '../lib/utils';
  import diff from 'microdiff';
  import router from '../lib/router';

  // component options  ------------------------------------------------------ //

  export let query;

  // internal variables  ------------------------------------------------------ //

  let saving_txt;
  let settings;
  let has_init = false;
  let wait_api = false;
  let has_saved = false;
  let changed = false;

  let is_ready = {
    profile_info: false,
  }

  let dialog_content = t9n(TS.SETTINGS_DO_YOU_WANT_TO_SAVE);
  let dialog_title = t9n(TS.SETTINGS_UNSAVED_CHANGES);
  let btn_save = t9n(TS.CHANGE_PASSWORD_SUBMIT_LABEL);
  let btn_yes = t9n(TS.TXT_NO);

  let phone;
  let tab_bar_items;

  let input = {
    personal: {},
    location: {},
    interests: {
      products: [],
    },
    accomplishments: {
      languages: null,
      educations: null,
    },
    experiences: [],
  };
  let input_copy;

  let validators = {
    personal: {
      email: true,
      iban: true,
      tax: true,
      ssn: true,
      video: true,
      linkedin: true,
      first_name: true,
      last_name: true,
      phone: true,
      company_name: true,
      registration_number_worker: true,
      organization_type: true,
      password: true,
      new_password: true,
      new_password_confirm: true,
    },
  };

  // utility functions  ------------------------------------------------------ //

  const collect_product_tags = () => {
    let tmp_products = [];

    for (let i = 0; i < input.interests.products.length; i++) {
      if (input.interests.products[i].value === true) {
        tmp_products.push(input.interests.products[i].tag_id);
      }
    }
    return tmp_products;
  };

  const set_phone = (country, code, number) => {
    phone = { country: country, code: code, number: number };
  };

  window.update_profile = async () => {
    changed = false;
    wait_api = true;

    let is_first_time = get_url_param();
    if (is_first_time) {
      set_all_products();
    }

    let tmp_educations = input.accomplishments.educations;
    let tmp_experiences = input.experiences;
    let tmp_languages = input.accomplishments.languages;
    for (let i = 0; i < tmp_educations.length; i++) {
      delete tmp_educations[i]['id'];
    }

    for (let i = 0; i < tmp_experiences.length; i++) {
      delete tmp_experiences[i]['id'];
    }

    for (let i = 0; i < tmp_languages.length; i++) {
      delete tmp_languages[i]['id'];
    }

    let common_data = {
      first_name: input.personal.first_name,
      last_name: input.personal.last_name,

      language: input.personal.language,
      profile_picture: input.personal.profile_picture,
      phone: {
        code: phone.code,
        country: phone.country,
        number: phone.number,
      },
      linked_in_link: input.personal.linked_in_link,
      organization_name: input.personal.organization.name,
      company_registration_number: input.personal.company_registration_number,
    };


    // console.log('prof', common_data.profile_picture);

    if (!!input.location.city) {
      let api_address = {
        city: input.location.city,
        latitude: input.location.latitude,
        longitude: input.location.longitude,
        postal_code: input.location.postal_code,
        primary_address: input.location.primary_address,
        region: input.location.region,
        secondary_address: input.location.secondary_address,
        country: input.location.country_code,
      };
      common_data.address = api_address;
      if(!common_data.address.postal_code) common_data.address.postal_code = "00000";
    }



    if ($session.user.email !== input.personal.email) {
      common_data.email = input.personal.email;
    }

    let orderer_data = {
      ...common_data,
      short_description_orderer: input.personal.short_description.orderer,
      organization_type: input.personal.organization.type,
      is_orderer: true,
    };

    let worker_data = {
      ...common_data,
      short_description_worker: input.personal.short_description.worker,
      worker_tax_percentage: parseFloat(input.personal.tax_amount) / 100,
      bank_account: input.personal.bank_account,
      ssn: input.personal.ssn,
      video_link: input.personal.video_link,
      cv_is_public: input.personal.cv_is_public,
      worker_type:
        input.personal.worker_type || $session.merchant.default_worker_type,
      distance: input.location.distance,
      product_tags: collect_product_tags(),
      educations: tmp_educations,
      experiences: tmp_experiences,
      languages: tmp_languages,
      is_worker: true,
      referee: input.personal.referee,
    };

    if ($session.merchant.distance.allow_unlimited_distance === true) {
      worker_data.can_see_orders_for_unlimited_distance =
        input.location.unlimited_distance;
    }

    let is_orderer =
      $session.user.last_role === 'orderer' ||
      (query && query.first_time === 'true' && query.role === 'orderer');

    if (input.personal.video_link === null) {
      worker_data.video_link = null;
    }

    let data = is_orderer ? orderer_data : worker_data;
    Object.keys(data).map(k => {
      if (data[k] === null) delete data[k];
    });

    let result = await APIClient.update_profile(data);
    wait_api = false;
    has_saved = true;
    if (result) window.location.assign('/home?save=true');
  };

  const load_products = () => {
    let tmp_array = [];
    for (let i = 0; i < $session.merchant.product_tags.length; i++) {
      let name;
      switch ($session.user.language) {
        case 'en':
          name =
            $session.merchant.product_tags[i].localized_names.translation_en;
          break;
        case 'ar':
          name =
            $session.merchant.product_tags[i].localized_names.translation_ar;
          break;
        case 'fa':
          name =
            $session.merchant.product_tags[i].localized_names.translation_fa;
          break;
        case 'fi':
          name =
            $session.merchant.product_tags[i].localized_names.translation_fi;
          break;
        case 'ru':
          name =
            $session.merchant.product_tags[i].localized_names.translation_ru;
          break;
        case 'sv':
          name =
            $session.merchant.product_tags[i].localized_names.translation_sv;
          break;
        case 'uk':
          name =
            $session.merchant.product_tags[i].localized_names.translation_uk;
          break;
        default:
          name =
            $session.merchant.product_tags[i].localized_names.translation_en;
      }

      let product = {
        name: name,
        value: get_url_param(),
        tag_id: $session.merchant.product_tags[i].tag_id,
      };
      tmp_array.push(product);
    }

    input.interests.products = tmp_array;

    input.interests.products.sort((a, b) => {
      return compareStrings(a.name, b.name);
    });
  };

  const set_products = () => {
    for (let i = 0; i < input.interests.products.length; i++) {
      if (
        $session.user.product_tags.includes(input.interests.products[i].tag_id)
      ) {
        input.interests.products[i].value = true;
      }
    }
  };

  const set_all_products = () => {
    for (let i = 0; i < input.interests.products.length; i++) {
      input.interests.products[i].value = true;
    }
  };

  const init_profile = async () => {
    document
      .querySelector('.mdc-top-app-bar--fixed-adjust')
      .scrollIntoView({ behavior: 'smooth' });
    settings = new Settings();

    let tax_amount = $session.user.worker_tax_percentage
      ? $session.user.worker_tax_percentage
      : 0;

    input.personal = {
      first_name: $session.user.first_name,
      last_name: $session.user.last_name,
      email: $session.user.email,
      language: $session.user.language,
      bank_account: $session.user.bank_account,
      tax_amount: (tax_amount * 100).toFixed(1),
      ssn: $session.user.ssn,
      phone: {
        number: $session.user.phone.number,
        code: $session.user.phone.code,
        country: $session.user.phone.country,
      },
      company_registration_number: !!$session.user.company_registration_number
        ? $session.user.company_registration_number
        : '',
      worker_type: $session.user.worker_type,
      short_description: {
        orderer: $session.user.short_description_orderer,
        worker: $session.user.short_description_worker,
      },
      video_link: $session.user.video_link,
      linked_in_link: $session.user.linked_in_link,
      organization: {
        name: $session.user.organization_name,
        type: $session.user.organization_type,
      },
      image_url: $session.user.profile_image_url,
      cv_is_public: $session.user.cv_is_public,
      referee: $session.user.referee,
    };


    input.location = {
      primary_address: $session.user.address.primary_address,
      secondary_address: $session.user.address.secondary_address,
      city: $session.user.address.city,
      region: $session.user.address.region,
      postal_code: $session.user.address.postal_code,
      longitude: $session.user.address.longitude,
      latitude: $session.user.address.latitude,
      distance: $session.user.distance,
      unlimited_distance: $session.user.can_see_orders_for_unlimited_distance,
    };

    input.accomplishments.languages = $session.user.languages;
    input.accomplishments.educations = $session.user.educations;
    input.experiences = $session.user.experiences;
    set_phone(
      $session.user.phone.country,
      $session.user.phone.code,
      $session.user.phone.number
    );
    let is_first_time = get_url_param();
    init_tab_bars(is_first_time);
    load_products();

    if (!is_first_time) {
      set_products();
    }
    input.accomplishments.languages.sort((a, b) => {
      return compareStrings(a.language, b.language);
    });
    input.accomplishments.educations.sort((a, b) => {
      return compareStrings(a.education_type, b.education_type);
    });
    input.experiences.sort((a, b) => {
      return compareStrings(a.position, b.position);
    });

    if ($session.user.address.longitude === null) {
      input.location.longitude = $session.merchant.country_default_longitude;
      input.location.latitude = $session.merchant.country_default_latitude;
    }
    if ($session.user.worker_type === null) {
      input.personal.worker_type = $session.merchant.default_worker_type;
    }
    input_copy = JSON.parse(JSON.stringify(input));
  };

  const get_url_param = () => {
    let url_string = window.location.href;
    let url = new URL(url_string);
    let param = url.searchParams.get('first_time') === 'true';
    let is_first_time = false;
    if(!$session.user.is_orderer && !$session.user.is_worker) is_first_time = true;
    return param || is_first_time;
  };

  const init_tab_bars = is_first_time => {
    if (!is_first_time) {
      if ($session.user.last_role === 'orderer') {
        tab_bar_items = [
          { name: 'Personal info', icon: null, validated: true },
          { name: 'Location', icon: null, validated: true },
        ];
      } else {
        tab_bar_items = [
          { name: 'Personal info', icon: null, validated: true },
          { name: 'Location', icon: null, validated: true },
          { name: 'Tasks interests', icon: null, validated: true },
          { name: 'Accomplishments', icon: null, validated: true },
          { name: 'Experiences', icon: null, validated: true },
        ];
      }
    } else {
      tab_bar_items = [
        { name: 'Personal info', icon: null, validated: true },
        { name: 'Location', icon: null, validated: true },
      ];
    }

    saving_txt = t9n(TS.NEW_ORDER_SAVING);
    tab_bar_items[0].name = t9n(TS.MENU_LABEL_PERSONALINFO);
    tab_bar_items[1].name = t9n(TS.TABLE_HEADER_LOCATION);

    if ($session.user.last_role === 'worker' && !is_first_time) {
      tab_bar_items[2].name = t9n(TS.MENU_LABEL_TASKINTERESTS);
      tab_bar_items[3].name = t9n(TS.MENU_LABEL_ACCOMPLISHMENTS);
      tab_bar_items[4].name = t9n(TS.MENU_LABEL_EXPERIENCES);
    }
  };

  //dont separate to settings.js
  window.next_tab = () => {
    if (settings.current_tab + 1 !== tab_bar_items.length) {
      settings.current_tab++;
    }
  };

  window.prev_tab = () => {
    if (settings.current_tab !== 0) {
      settings.current_tab--;
    }
  };

  const set_tabs = val => {
    for (let i = 1; i < tab_bar_items.length; i++) {
      tab_bar_items[i].validated = val;
    }
  };

  const validate_inputs = validator => {
    settings.is_valid = true;
    for (let key in validator) {
      if (!validator[key]) {
        settings.is_valid = false;
      }
    }
    set_tabs(settings.is_valid);
  };

  const on_destroy = () => {
    if (changed && !has_saved) {
      toggle_dialog()
    }
  };

  const create_change_dialog = () => {
    let target = document.querySelector('.layout-dialog');

    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'sure-message',
        title: dialog_title,
        content: dialog_content,
        buttons: [
          {
            label: btn_save,
            action: () => {
              window.update_profile();
              dialog.close();
            },
            classes: [],
          },
          {
            label: btn_yes,
            id: 'yes_switch',
            action: () => {
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });

    return dialog;
  };

  const toggle_dialog = () => {
    let dialog = create_change_dialog();
    dialog.open();
  };

  const set_changed = input => {

      let difference = diff(input, input_copy);
      if (difference.length > 0) {
        changed = true;
      } else if (difference.length === 0) {
        changed = false;
      }

  };

  // reactive functions  ------------------------------------------------------ //

  $: if (!!$session && !input.location.latitude && !has_init) {
    init_profile();
    has_init = true;
  }

  $: validate_inputs(validators.personal);
  $: set_changed(input);

  onDestroy(on_destroy);
</script>

  <main style="margin-bottom: 50px">
  <div class="mdc-card">
    <div style="margin-top: 0px">
      <TabBar
        validate={true}
        bind:current_tab={settings.current_tab}
        {tab_bar_items}
        padding="0px" />
    </div>

    <!--        {/if}-->
    <div style="margin: 24px;">
      {#if settings.current_tab === 0}
        <ProfileInfo
          bind:is_valid={settings.is_valid}
          bind:validators={validators.personal}
          bind:input={input.personal}
          bind:phone
          bind:is_ready={is_ready.profile_info}
          is_first_time={get_url_param()} />
      {:else if settings.current_tab === 1}
        <Location
          bind:input={input.location}
          variant={'filled'}
          is_first_time={get_url_param()}
          {wait_api}
          page={'settings'} />
      {:else if settings.current_tab === 2}
        <WorkerProfileTaskInterests bind:input={input.interests} />
      {:else if settings.current_tab === 3}
        <WorkerAccomplishments bind:input={input.accomplishments} />
      {:else if settings.current_tab === 4}
        <WorkerExperiences
          bind:input
          bind:experiences={input.experiences}
          {wait_api} />
      {/if}
    </div>
  </div>

  <div class="change-dialog" />
</main>

<style type="text/scss">
  .mdc-card {
    position: relative;
  }

  p {
    display: inline;
    margin-left: 47px;
    opacity: 0;
    transition: all 0.5s ease;
  }

  .saving-text {
    opacity: 1 !important;
    transition: all 0.5s ease;
  }

  main {
    display: flex;
    flex-direction: column;
    margin-top: 3rem !important;
    padding: 0.5rem 0.5rem;
    background: #ffffff8c;
    border-radius: 10px;
  }

  /* Desktop Mode
        *******************************************************/
  @media (min-width: 1025px) {
    main {
      width: 1000px;
      margin: 0 auto;
      height: fit-content;
    }
  }

  /* Tablet Mode
        *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    main {
      width: 90%;
      margin: 0 auto;
      height: fit-content;
    }
  }

  /* Mobile Mode
        *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    main {
      width: 100%;
      margin: 0 auto;
      height: fit-content;
      margin-bottom: 100px;
      padding: 0;
      border-radius: 0;
    }
  }
</style>
